import http from '@/utils/http';
const base_path = '/v2/creative';

/**
 * 获取创意列表接口
 * @param {Object} params 接口请求参数
 * @returns {Promise<Object>}
 */
export const getCreativeListApi = (params) => {
  return http.get({
    url: base_path,
    params,
  });
};

/**
 * 同步创意状态接口
 * @param {Object} params 接口请求参数
 * @returns {Promise<Object>}
 */
export const pullCreativeStatusApi = (params) => {
  return http.get({
    url: `${base_path}/pullStatus`,
    params,
  });
};

/**
 * 获取创意详情接口
 * @param {string} id 广告id
 * @param {Object} params 接口请求参数
 * @returns {Promise<Object>}
 */
export const getCreativeDetailApi = (id, params) => {
  return http.get({
    url: `${base_path}/${id}`,
    params,
  });
};

/**
 * 更新创意接口
 * @param {string} id 创意id
 * @param {Object} data 接口请求参数
 * @returns {Promise<Object>}
 */
export const editCreativeApi = (id, data) => {
  return http.put({
    url: `${base_path}/${id}`,
    data,
  });
};

/**
 * 更新创意状态接口
 * @param {string} id 创意id
 * @param {Object} data 接口请求参数
 * @returns {Promise<Object>}
 */
export const updateCreativeStatusApi = (id, data) => {
  return http.put({
    url: `${base_path}/updateStatus/${id}`,
    data,
  });
};

/**
 * 删除创意
 * @param {Object} data 接口请求参数
 * @returns {Promise<Object>}
 */
export const deteleCreativeApi = (data) => {
  return http.delete({
    url: `${base_path}/delete`,
    data,
  });
};

/**
 * 获取动态渲染组件接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export const getDynamicComponentApi = (params) => {
  return http.get({
    url: `${base_path}/dynamicComponent`,
    params,
  });
};

/**
 * 获取创意规格列表接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export const getCreativeTemplateApi = (params) => {
  return http.get({
    url: `${base_path}/template`,
    params,
  });
};
